import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectContactPhone = createSelector(
  selectJsonQuery,
  jsonQuery => getTermValue('contact')(jsonQuery) || '',
);
